import React from 'react';
import { Divider, Card as MuiCard } from '@mui/material';
import { Box, Typography } from 'components/index';
import WhiteFab from '../../components/common/WhiteFab';
import { Edit } from '@mui/icons-material';

interface SimpleCardProps {
  icon?: JSX.Element;
  heading?: string | JSX.Element;
  subHeading?: string;
  headerAction?: JSX.Element;
  children?: React.ReactNode;
  footer?: JSX.Element;
  backgroundColor?: string;
  isEditMode?: boolean;
  showEditIcon?: boolean;
  onEditClick?: () => void;
  disableActions?: boolean;
  alignItems?: string;
}

const SimpleCard: React.FC<SimpleCardProps> = ({
  icon,
  heading,
  subHeading,
  headerAction,
  children,
  footer,
  backgroundColor,
  showEditIcon,
  onEditClick,
  isEditMode,
  disableActions,
  alignItems = 'center',
}) => {
  let actions = null;
  if (!disableActions) {
    actions = (
      <Box alignSelf={'flex-end'}>
        {headerAction ?? null}
        {showEditIcon && !isEditMode && (
          <WhiteFab aria-label='edit' icon={<Edit fontSize='small' />} textColor='primary' onClick={onEditClick} size='small' />
        )}
      </Box>
    );
  }
  return (
    <MuiCard elevation={3} sx={{ p: 2, width: '100%', height: '100%', backgroundColor: backgroundColor, alignItems: alignItems }}>
      <Box display='flex' alignItems='center' justifyContent={'space-between'}>
        <Box display='flex' flexDirection='column'>
          <Box display='flex' alignItems='center' flexDirection='row'>
            {icon}
            {heading && (
              <Typography variant='h5' color='primary' sx={{ ml: icon ? 1 : 0 }}>
                {heading}
              </Typography>
            )}
          </Box>
          {subHeading && (
            <Typography variant='caption' color='secondary' fontWeight='regular' sx={{ mt: 1 }}>
              {subHeading}
            </Typography>
          )}
        </Box>
        {actions}
      </Box>
      {(icon || heading) && <Divider sx={{ mb: 2 }} />}
      {children}
      <Box display='flex' alignItems='center' sx={{ marginTop: 'auto' }}>
        {footer}
      </Box>
    </MuiCard>
  );
};

export default SimpleCard;
